declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

type EventName = 'CompleteRegistration' | 'Lead' | 'Subscribe';


export interface CapiDedupePayload {
  event_id: string;
  event_source_url: string;
  fbp: string;
  fbc: string;
}

function fire(
  event: EventName,
  params?: Record<string, unknown>,
  eventID?: string,
): void {
  try {
    if (typeof window === 'undefined') return;
    const fbq = window.fbq;
    if (typeof fbq !== 'function') return;
    const opts = eventID ? { eventID } : undefined;
    if (params && opts) fbq('track', event, params, opts);
    else if (params) fbq('track', event, params);
    else fbq('track', event);
  } catch {

  }
}

function uuid(): string {
  try {
    const c: any = (globalThis as any).crypto;
    if (c?.randomUUID) return c.randomUUID();
  } catch {
    
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function readCookie(name: string): string {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(
    new RegExp('(^|;\\s*)' + name + '=([^;]+)'),
  );
  return match ? decodeURIComponent(match[2]) : '';
}


export function prepareVendorRegistrationCapi(): CapiDedupePayload {
  return {
    event_id: uuid(),
    event_source_url:
      typeof window !== 'undefined' ? window.location.href : '',
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc'),
  };
}


export function fireVendorCompleteRegistration(
  method: 'email_phone' | 'google',
  eventId: string,
): void {
  fire(
    'CompleteRegistration',
    {
      content_name: 'Vendor Registration',
      registration_method: method,
      status: true,
    },
    eventId,
  );
}
